import React, { useState, useEffect } from 'react';
import './FloatingButtons.css';

const FloatingButtons: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const whatsappMessage = `Olá! Gostaria de solicitar um orçamento para desenvolvimento de landing page/site institucional/catálogo digital.`;
  const whatsappUrl = `https://wa.me/5528999921986?text=${encodeURIComponent(whatsappMessage)}`;

  return (
    <div className="floating-buttons">
      {/* WhatsApp Button */}
      <a 
        href={whatsappUrl} 
        target="_blank" 
        rel="noopener noreferrer"
        className="floating-btn whatsapp-btn"
        title="Fale conosco no WhatsApp"
      >
        <div className="btn-icon">📱</div>
        <div className="btn-text">WhatsApp</div>
        <div className="pulse-ring"></div>
      </a>

      {/* Email Button */}
      <a 
        href="mailto:contato@genesystecnologia.com.br"
        className="floating-btn email-btn"
        title="Envie um e-mail"
      >
        <div className="btn-icon">📧</div>
        <div className="btn-text">E-mail</div>
      </a>

      {/* Scroll to Top Button */}
      {isVisible && (
        <button 
          onClick={scrollToTop}
          className="floating-btn scroll-top-btn"
          title="Voltar ao topo"
        >
          <div className="btn-icon">↑</div>
        </button>
      )}

      {/* Urgency Banner */}
      <div className="floating-urgency">
        <div className="urgency-content">
          <span className="urgency-text">🔥 Oferta limitada!</span>
          <span className="urgency-subtext">Apenas 3 vagas restantes</span>
        </div>
        <a href="#contato" className="urgency-btn">
          Garantir Vaga
        </a>
      </div>
    </div>
  );
};

export default FloatingButtons;